import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { PHARMACY_COPY } from '../pharmacyCopy';
import { CENTRAL_PHARMACY_PATHS, PHARMACIST_PATHS } from '../pharmacyPaths';

const copy = PHARMACY_COPY.DISPENSATIONS;

export const DISPENSATION_STATUSES = ['', 'PENDING', 'DISPENSED', 'CANCELLED'];

export const SOURCE_FILTERS = [
  { value: '', label: copy.FILTER_SOURCE_ALL },
  { value: 'PRESCRIPTION', label: copy.FILTER_SOURCE_RX },
  { value: 'MANUAL', label: copy.FILTER_SOURCE_MANUAL }
];

export const FLOW_STEPS = [
  { id: 'PENDING', label: copy.FLOW_PENDING },
  { id: 'DISPENSED', label: copy.FLOW_DISPENSED }
];

export function useDispensationRoutes() {
  const { pathname } = useLocation();
  const isPharmacist = pathname.startsWith('/pharmacist');
  return useMemo(() => {
    const base = isPharmacist ? PHARMACIST_PATHS : CENTRAL_PHARMACY_PATHS;
    return {
      LIST: base.DISPENSATIONS,
      NEW: base.DISPENSATION_NEW,
      DETAIL: base.DISPENSATION_DETAIL
    };
  }, [isPharmacist]);
}

export function dispensationStatusClass(status) {
  if (status === 'DISPENSED') return 'cp-status-pill--ok';
  if (status === 'CANCELLED') return 'cp-status-pill--muted';
  if (status === 'PENDING') return 'cp-status-pill--warn';
  return 'cp-status-pill--muted';
}

export function nextDispenseActionLabel(status) {
  if (status === 'PENDING') return copy.NEXT_PENDING;
  if (status === 'DISPENSED') return copy.NEXT_DISPENSED;
  if (status === 'CANCELLED') return copy.NEXT_CANCELLED;
  return '';
}

export function severityPillClass(severity) {
  if (severity === 'MAJOR') return 'cp-status-pill--danger';
  if (severity === 'MODERATE') return 'cp-status-pill--warn';
  if (severity === 'MINOR') return 'cp-status-pill--info';
  return 'cp-status-pill--ok';
}

function flowIndex(status) {
  if (status === 'CANCELLED') return -1;
  return FLOW_STEPS.findIndex((s) => s.id === status);
}

export function DispensationFlow({ status }) {
  if (status === 'CANCELLED') {
    return (
      <div className="cp-order-flow cp-order-flow--cancelled" aria-label={copy.FLOW_TITLE}>
        <span className="cp-status-pill cp-status-pill--muted">{copy.FLOW_CANCELLED}</span>
      </div>
    );
  }
  const active = flowIndex(status);
  return (
    <ol className="cp-order-flow" aria-label={copy.FLOW_TITLE}>
      {FLOW_STEPS.map((step, i) => {
        let state = 'upcoming';
        if (i < active) state = 'done';
        else if (i === active) state = 'current';
        return (
          <li key={step.id} className={`cp-order-flow__step is-${state}`}>
            <span className="cp-order-flow__dot" aria-hidden>
              {state === 'done' ? '✓' : i + 1}
            </span>
            <span className="cp-order-flow__label">{step.label}</span>
          </li>
        );
      })}
    </ol>
  );
}
